import gql from "graphql-tag";

export const requestInfoFragment = gql`
fragment requestInfo on RequestInfo{
    _id
    message
    lang
    company
    telephone
    requestType
    createdAt
    requestStatus
    originalMessage
}
`;